/**
 * 文章相关请求模块
 */
import { requestMaster, request, requestBjh, requestBjhField, requestBjhRank } from '@/utils/request'

/**
 * 北京号号主页号主信息
 */
export const getMasterInfo = (columnId) => {
  return requestMaster({
    method: 'GET',
    url: `api/neusoft/channelUUID/${columnId}`
    // url: `/mps-web/pub/v1/channels/default/publishers/columns?columnIds=${columnId}`
  })
}

/**
 * 北京号号主页
 */
export const getArticles = (channelId, lastStoryId) => {
  return request({
    method: 'GET',
    url: `/rest/site/api/bjrbbeijinghao/bjhStory/${channelId}/0/list/c/10/ls/${lastStoryId}/lc/10.json`
  })
}

/**
 * 北京号新闻列表
 */
export const getBjhArticlsList = params => {
  return requestBjh({
    method: 'GET',
    // url: `/rest/site/api/bjrbbeijinghao/bjhStory/bjh/${params.page}/list/c/${params.count}/ls/${params.lastStoryId}/lc/${params.lastCount}/${params.uid}.json`
    url: `/rest/site/api/bjrbbeijinghao/bjhStory/bjh/${params.page}/list/c/10/ls/${params.lastStoryId}/lc/${params.lastCount}.json`
    // https://bj.bjd.com.cn/rest/site/api/bjrbbeijinghao/bjhStory/bjh/3/list/c/10/ls/blank/lc/0.json
  })
}

/**
 * 获取北京号领域列表
 */
export const getBjhFieldList = params => {
  return requestBjhField({
    method: 'GET',
    url: `/api/bjhField/list/${params.uid}`
  })
}

/**
 * 获取北京号领域列表一级条目
 */
export const getBjhFieldItems = params => {
  return requestBjhField({
    method: 'GET',
    url: `/api/bjhField/fieldItem/${params.fieldId}/${params.uid}`
  })
}

/**
 * 获取北京号领域列表二级条目
 */
export const getBjhFieldZonesItems = params => {
  return requestBjhField({
    method: 'GET',
    url: `/api/bjhField/zoneBjhUsers/${params.fieldId}/${params.zoneId}/${params.uid}`
  })
}

/**
 * 获取北京号榜单号主排名
 */
export const getBjhRankMasterList = params => {
  return requestBjhRank({
    method: 'GET',
    // url: `comment/api/bjh/heatDegreeTotal/sort/startDate/${params.startDate}/endDate/${params.endDate}/count/${params.count}.json`
    url: `/dss/rest/v1/heat-weeks/sort/period/${params.period}.json`
  })
}

/**
 * 获取北京号榜单号主信息
 */
export const getBjhRankBjhinfo = params => {
  return requestBjhField({
    method: 'GET',
    // url: `comment/api/bjh/heatDegreeTotal/sort/startDate/${params.startDate}/endDate/${params.endDate}/count/${params.count}.json`
    // url: `api/neusoft/channelUUID/${params.columnId}`
    url: `/mps-web/pub/v1/channels/default/publishers/columns?columnIds=${params.columnId}`

  })
}

/**
 * 获取北京号榜单热门文章排名
 */
export const getBjhRankArticleList = params => {
  return requestBjhRank({
    method: 'GET',
    url: 'dss/rest/v1/heat-article-days/sort.json'
  })
}

/**
 * 获取北京号榜单号主排名
 */
export const getBjhRankHistoryList = () => {
  return requestBjhRank({
    method: 'GET',
    // url: 'comment/api/bjh/heatDegreeTotal/week/peroids.json'
    url: 'dss/rest/v1/heat-weeks/periods.json'
  })
}
